import type { AwardQuerySchema } from '../schemas';

export const fieldNames: Record<keyof AwardQuerySchema, { name: string; revertible: boolean }> = {
  id: { name: 'ID', revertible: true },
  name: { name: 'Award Name', revertible: true },

  award_month: { name: 'Award Month', revertible: true },
  award_year: { name: 'Award Year', revertible: true },
  sponsoring_organization: { name: 'Sponsoring Organization', revertible: true },
  brand_id: { name: 'Brand ID', revertible: true },
  award_type: { name: 'Award Type', revertible: true },
  client_id: { name: 'Client ID', revertible: true },
  notes: { name: 'Notes', revertible: true },

  brand: { name: 'Brand', revertible: true },
  client: { name: 'Client', revertible: true },
  gallery: { name: 'Gallery', revertible: true },
};
